import { jsx } from '@amzn/shiv'

export function PartyView() {
    return (
        <div className="partyView">
            <h1>Party On!</h1>
            <div className="subtitle">Add a song to the party:</div>
            <div className="partyStage" />
        </div>
    )
}
